/**
 * FileMakerTypes.ts - FileMaker-specific type definitions for Interactr
 * 
 * CHANGE HISTORY:
 * - 251201_0405 danielbeer: Created FileMaker types for Interactr data sources
 */

/**
 * FileMaker OData configuration
 */
export interface FileMakerODataConfig {
  server: string;
  database: string;
  table: string;
  query?: {
    filter?: string;
    select?: string[];
    orderBy?: string;
    top?: number;
    skip?: number;
  };
  authentication: {
    type: 'basic' | 'oauth';
    username?: string;
    password?: string;
    token?: string;
  };
}

/**
 * FileMaker Data API configuration
 */
export interface FileMakerDataAPIConfig {
  server: string;
  database: string;
  layout: string;
  query?: {
    findRequest?: any[];
    sort?: any[];
    limit?: number;
    offset?: number;
  };
  authentication: {
    username: string;
    password: string;
  };
  fieldMapping?: Record<string, string>;
}

/**
 * FileMaker Script configuration
 */
export interface FileMakerScriptConfig {
  scriptName: string;
  parameters?: Record<string, any>;
  resultPath?: string;  // JSONPath to extract data from script result (default: $.JSON)
  webViewerContext?: boolean;  // Execute from WebViewer context
}

/**
 * Default FileMaker Script configuration
 */
export const DEFAULT_FM_SCRIPT_CONFIG: Partial<FileMakerScriptConfig> = {
  scriptName: 'jsRunScript',
  resultPath: '$.JSON',
  parameters: {},
  webViewerContext: false
};

/**
 * FileMaker Script Patterns
 */
export type ScriptPattern = 'custom' | 'sql-query' | 'table-data' | 'field-list' | 'get-schema';

export interface ScriptPatternConfig {
  pattern: ScriptPattern;
  name: string;
  description: string;
  defaultParams: Record<string, any>;
  scriptTemplate?: string;
}

/**
 * Standard FileMaker Script Actions
 */
export const FM_SCRIPT_ACTIONS = {
  GET_SCHEMA: 'GetSchema',
  SQL_QUERY: 'ExecuteSQL',
  GET_TABLE_DATA: 'GetTableData',
  GET_FIELDS: 'GetFields'
} as const;
